import {Action, ActionReducer, createReducer, on} from "@ngrx/store";
import {LanguagesState} from "./languages";
import * as languages from "./languages.actions";
import {Serializer} from '../../interfaces/serializer';
import {Language} from '../../interfaces/language';

const reducer: ActionReducer<LanguagesState> = createReducer(
  { languages: [], language: null, languageCode: 'en', loading: false, loaded: false } as LanguagesState,
  on(languages.loadLanguages, (state: LanguagesState) => {
    return {
      ...state,
      loading: true
    }
  }),
  on(languages.loadLanguagesSuccess, (state: LanguagesState, action): LanguagesState => {
    const language: Serializer<Language> = action.languages.find((lang: Serializer<Language>): boolean => lang.attributes.code === action.profile.attributes.language);

    return {
      ...state,
      loading: false,
      loaded: true,
      languages: action.languages,
      language: language,
      languageCode: language.attributes.code
    }
  }),
  on(languages.updateLanguages, (state: LanguagesState): LanguagesState => {
    return { ...state, loading: true };
  }),
  on(languages.updateLanguagesSuccess, (state: LanguagesState, action): LanguagesState => {
    return {
      ...state,
      language: action.language,
      languageCode: action.language.attributes.code,
      loading: false
    };
  })
);

export const languagesReducer: ActionReducer<LanguagesState> = (state: LanguagesState, action: Action) => {
  return reducer(state, action);
}
